import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putUser } from '../Api'

export default generateApiAction({
  baseType: Types.USERS.PUT,
  api: putUser,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/users/PutAction.js